module.exports = __webpack_public_path__ + "media/images/area/feature/banner/en/sp/en_setouchi-5077661baf185474edb37be05df34fb2.png";